import React from 'react';
import { PillCell } from 'BlockList/components/BlockListTable/cells/PillCell';
import type { AttributeTypeKey } from 'BlockList/types';
import styles from './AttributePill.module.css';

type AttributePillsProps = {
  attributeTypes: AttributeTypeKey[];
};

export const AttributePills: React.FC<AttributePillsProps> = ({
  attributeTypes,
}) => {
  if (attributeTypes.length === 0) {
    return <span>—</span>;
  }

  return (
    <div className={styles.group}>
      {attributeTypes.map((attr) => (
        <PillCell key={attr} label={attr} className={styles.pill} />
      ))}
    </div>
  );
};
